import { FormBuilderService } from '../../../services/form-builder.service';
import {
  IBaseConfigurationFormModel,
  IFormbuilderFieldTypeConfiguration,
} from '../../../models/form-builder-types-configurations.model';
import { fieldsBaseConfigurationFormModel } from './shared.configuration';
import {
  baseFieldParseIntoSettingsFormModel,
  baseFieldUpdateFromSettingsFormModel,
  getDefaultBaseSettingsConfigFormly,
} from '../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  getMaxLengthValidatorFormConfig,
  getMinLengthValidatorFormConfig,
  getRequiredValidatorFormConfig,
  getValidationFieldsFormConfig,
} from '../form-fields-formly-validations/form-fields-formly-validation-field-generator.util';
import { getConditionalValidationsFormConfig } from '../form-fields-formly-validations/conditional-validations/fields-formly-conditional-validation-field-generator.util';
import { EAvailableConditionalValidations } from '../../../models/form-fields-formly-conditional-validation.model';
import { getFieldDisplayFormConfig } from '../form-fields-formly-display/form-fields-formly-display-field-generator.util';
import { IFormFieldsValidationModel } from '../../../models/form-fields-formly-validation.model';
import {
  parseMaxLengthValidatorParseFieldIntoModel,
  parseMinLengthValidatorParseFieldIntoModel,
  parseRequiredValidatorParseFieldIntoModel,
} from '../form-fields-formly-validations/form-fields-formly-validation-field-parse-to-model.util';
import { parseConditionalValidatorsModelFromFieldIntoModel } from '../form-fields-formly-validations/conditional-validations/fields-formly-conditional-validation-field-parse-to-model.util';
import {
  setMaxLengthValidatorUpdateFieldFromModel,
  setMinLengthValidatorUpdateFieldFromModel,
  setRequiredValidatorUpdateFieldFromModel,
} from '../form-fields-formly-validations/form-fields-formly-validation-field-set-from-model.util';
import { setConditionalExpressionFromModel } from '../form-fields-formly-validations/conditional-validations/fields-formly-conditional-validation-field-set-from-model.util';
import { IFormFieldsDisplayModel } from '../../../models/form-fields-formly-display.model';
import { parseFieldIntoDisplayFormModel } from '../form-fields-formly-display/form-fields-formly-display-field-parse-to-model.util';
import { setDisplayHideExpressionFromModel } from '../form-fields-formly-display/form-fields-formly-display-field-set-from-model.util';

const defaultCurrencyFormatInputConfigFormModel: IBaseConfigurationFormModel = {
  ...fieldsBaseConfigurationFormModel(),
};

export const currencyFormatInputFieldGetConfigurationConfig = (
  formBuilderServiceInstance: FormBuilderService
): IFormbuilderFieldTypeConfiguration => {
  return {
    settings: {
      formModel: defaultCurrencyFormatInputConfigFormModel,
      formlyForm: [
        ...getDefaultBaseSettingsConfigFormly(formBuilderServiceInstance),
      ],
    },
    validations: {
      formModel: {},
      formlyForm: [
        ...getCurrencyFormatInputFieldValidationConfiguration(
          formBuilderServiceInstance
        ),
        getCurrencyFormatInputConditionalValidationConfiguration(
          formBuilderServiceInstance
        ),
      ],
    },
    display: {
      formModel: {},
      formlyForm: [...getFieldDisplayFormConfig(formBuilderServiceInstance)],
    },
  };
};

export const currencyFormatInputFieldParseIntoSettingsFormModel = (
  field: FormlyFieldConfig
): IBaseConfigurationFormModel => {
  return baseFieldParseIntoSettingsFormModel(field);
};

export const currencyFormatInputFieldUpdateFromSettingsFormModel = (
  model: IBaseConfigurationFormModel,
  currencyFormatInputField: FormlyFieldConfig
): FormlyFieldConfig => {
  return baseFieldUpdateFromSettingsFormModel(model, currencyFormatInputField);
};

export const currencyFormatInputFieldParseIntoValidationFormModel = (
  field: FormlyFieldConfig
): IFormFieldsValidationModel => {
  let model: IFormFieldsValidationModel = {};

  model = parseRequiredValidatorParseFieldIntoModel(model, field);

  if (!field?.props?.type) {
    model = parseMinLengthValidatorParseFieldIntoModel(model, field);
    model = parseMaxLengthValidatorParseFieldIntoModel(model, field);
  }

  model = parseConditionalValidatorsModelFromFieldIntoModel(model, field);

  return model;
};

export const currencyFormatInputFieldUpdateFromValidationFormModel = (
  model: IFormFieldsValidationModel,
  currencyFormatInputField: FormlyFieldConfig
): FormlyFieldConfig => {
  currencyFormatInputField = setRequiredValidatorUpdateFieldFromModel(
    model,
    currencyFormatInputField
  );

  if (!currencyFormatInputField.props?.type) {
    currencyFormatInputField = setMinLengthValidatorUpdateFieldFromModel(
      model,
      currencyFormatInputField
    );
    currencyFormatInputField = setMaxLengthValidatorUpdateFieldFromModel(
      model,
      currencyFormatInputField
    );
  }

  currencyFormatInputField = setConditionalExpressionFromModel(
    model,
    currencyFormatInputField
  );

  return currencyFormatInputField;
};

export const currencyFormatInputFieldParseFieldIntoDisplayFormModel = (
  field: FormlyFieldConfig
): IFormFieldsDisplayModel => {
  return parseFieldIntoDisplayFormModel(field);
};

export const currencyFormatInputFieldUpdateFromDisplayFormModel = (
  model: IFormFieldsDisplayModel,
  field: FormlyFieldConfig
): FormlyFieldConfig => {
  return setDisplayHideExpressionFromModel(model, field);
};

const getCurrencyFormatInputFieldValidationConfiguration = (
  formBuilderServiceInstance: FormBuilderService
) => {
  const configuredField: FormlyFieldConfig | null =
    formBuilderServiceInstance.configureFieldAction$.getValue();

  const validationConfigFields: FormlyFieldConfig[] = [
    getRequiredValidatorFormConfig(),
  ];
  if (!configuredField?.props?.type) {
    validationConfigFields.push(
      ...[getMinLengthValidatorFormConfig(), getMaxLengthValidatorFormConfig()]
    );
  }

  validationConfigFields.push(
    getValidationFieldsFormConfig(formBuilderServiceInstance)
  );
  return validationConfigFields;
};

const getCurrencyFormatInputConditionalValidationConfiguration = (
  formBuilderServiceInstance: FormBuilderService
): FormlyFieldConfig => {
  return getConditionalValidationsFormConfig(
    [
      EAvailableConditionalValidations.required,
      EAvailableConditionalValidations.minLength,
      EAvailableConditionalValidations.maxLength,
    ],
    formBuilderServiceInstance
  );
};
